export class NombrePilaVariacion {
    [key: string]: string | number | undefined
    public id: number | undefined;
    public variacion: string | undefined;
    public nombrePila: string | undefined;
}